import React, {Fragment, useContext} from "react";
import {TranslateContext} from "../../../../../context/TranslateContext.jsx";
import ModalConfirm from "../../../../../components/ModalConfirm.jsx";
import CaricamentoInCorso from "../../../../../components/CaricamentoInCorso.jsx";
import NsButtonActionsGroup from "../../../../../components/buttons/NsButtonActionsGroup.jsx";
import NsButtonAction from "../../../../../components/buttons/NsButtonAction.jsx";
import {useTabellaSchedulazioni} from "./useTabellaSchedulazioni.jsx";
import ModalMsg from "../../../../../components/ModalMsg";
import DataTableCmms from "../../../../../components/tabelle/NsDataTable";
import {useFrequenzaSchedulazione} from "../../../hooks/useFrequenzaSchedulazione";

export default function TabellaSchedulazioni() {

    const {
        loadingData,
        schedulazioni,
        schedSel,
        setSchedSel,
        showConfirmDelete,
        setShowConfirmDelete,
        deleteSchedulazione,
        modalMsg,
        closeModal,
        show,
        funzioneFiltro,
    } = useTabellaSchedulazioni();

    const {
        getDescrizioneFrequenza,
        getDescrizioneGiornoSettimana,
        getDescrizioneMese,
    } = useFrequenzaSchedulazione();

    const {traduci} = useContext(TranslateContext);

    return (
        <Fragment>
            <ModalMsg
                show={show}
                handleClose={closeModal}
                testo={modalMsg}/>
            <ModalConfirm
                show={showConfirmDelete}
                handleClose={() => setShowConfirmDelete(false)}
                handleOk={deleteSchedulazione}
                testo={traduci("Sicuro di voler rimuovere la schedulazione: ") + (schedSel && schedSel.codice) + "?"}/>
            {
                loadingData ? (
                    <CaricamentoInCorso/>
                ) : (
                    <DataTableCmms
                        data={schedulazioni}
                        columns={[
                            {
                                name: 'Installazione',
                                selector: row => row.descrizione_installazione,
                                sortable: true,
                            },
                            {
                                name: 'Batch',
                                selector: row => row.descrizione_batch,
                                sortable: true,
                            },
                            {
                                name: 'Endpoint',
                                selector: row => row.endpoint_installazione + row.endpoint_batch,
                                sortable: true,
                            },
                            {
                                name: 'Ora schedulazione',
                                selector: row => row.ora_sched,
                                sortable: true,
                            },
                            {
                                name: 'Frequenza',
                                selector: row => getDescrizioneFrequenza(row.frequenza),
                                sortable: true,
                            },
                            {
                                name: 'Giorno settimana',
                                selector: row => getDescrizioneGiornoSettimana(row.giorno_settimana),
                                sortable: true,
                            },
                            {
                                name: 'Giorno mese',
                                selector: row => row.giorno_mese || '',
                                sortable: true,
                            },
                            {
                                name: 'Mese',
                                selector: row => getDescrizioneMese(row.mese) || '',
                                sortable: true,
                            },
                            {
                                name: '',
                                selector: row => <Fragment>
                                    <NsButtonActionsGroup>
                                        <li>
                                            <NsButtonAction
                                                label={"Modifica"}
                                                icona={"fas fa-pen"}
                                                href={`/upd-schedulazione/${row.id_schedulazione}`}
                                            />
                                        </li>
                                        <li>
                                            <NsButtonAction
                                                label={"Elimina"}
                                                icona={"fas fa-trash"}
                                                onClick={() => {
                                                    setSchedSel(row)
                                                    setShowConfirmDelete(true);
                                                }}
                                            />
                                        </li>
                                    </NsButtonActionsGroup>
                                </Fragment>,
                                sortable: false,
                                right: true,
                            }
                        ]}
                        funzioneFiltro={funzioneFiltro}
                    />
                )
            }
        </Fragment>
    );

}